'use client';

/**
 * VirzaMark — the Virza prism logo SVG.
 *
 * Kept in its own tiny module so surfaces that only need the brand mark
 * (BrandedLoadingScreen, not-found, error, app-shell gate) don't pull in
 * auth-layout's heavier dependencies (framer-motion, sonner, OAuth helpers).
 */

interface VirzaMarkProps {
  variant?: 'dark' | 'light' | 'auto';
  size?: number;
}

export function VirzaMark({ variant = 'dark', size = 32 }: VirzaMarkProps) {
  if (variant === 'auto') {
    return (
      <svg width={size} height={size} viewBox="0 0 512 512" fill="none">
        <path d="M84 64 L156 64 L256 352 L256 448 L69 89 Z" fill="currentColor" />
        <path d="M356 64 L428 64 L443 89 L256 448 L256 352 Z" fill="currentColor" opacity="0.7" />
        <line
          x1="256"
          y1="352"
          x2="256"
          y2="448"
          stroke="currentColor"
          strokeWidth="1.5"
          opacity="0.12"
        />
      </svg>
    );
  }
  if (variant === 'dark') {
    return (
      <svg width={size} height={size} viewBox="0 0 512 512" fill="none">
        <path d="M84 64 L156 64 L256 352 L256 448 L69 89 Z" fill="#ffffff" />
        <path d="M356 64 L428 64 L443 89 L256 448 L256 352 Z" fill="#ffffff" opacity="0.7" />
        <line
          x1="256"
          y1="352"
          x2="256"
          y2="448"
          stroke="#ffffff"
          strokeWidth="1.5"
          opacity="0.12"
        />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" fill="none">
      <path d="M84 64 L156 64 L256 352 L256 448 L69 89 Z" fill="#000000" />
      <path d="M356 64 L428 64 L443 89 L256 448 L256 352 Z" fill="#000000" opacity="0.7" />
      <line x1="256" y1="352" x2="256" y2="448" stroke="#000000" strokeWidth="1.5" opacity="0.12" />
    </svg>
  );
}
